import React from 'react';
import { Bot, BookOpen, Gamepad2 } from 'lucide-react';
import AIInterface from './AIInterface';
import FlashCards from './FlashCards';
import QuizGame from './QuizGame';
import './AiPane.css';

const AiPane = ({
  pdfData,
  currentPage,
  activeTab,
  onTabChange,
  isLoadingAnswer,
  setIsLoadingAnswer,
  setAnswerText,
}) => {
  const disableTabs = Boolean(isLoadingAnswer);

  return (
    <aside className="ai-section ai-pane" aria-label="AI Pane">
      <div className="tabs ai-pane__tabs" role="tablist" aria-label="Painel">
        <button
          type="button"
          className={`tab-button ${activeTab === 'ai' ? 'active' : ''}`}
          onClick={() => onTabChange('ai')}
          disabled={disableTabs}
          role="tab"
          aria-selected={activeTab === 'ai'}
        >
          <Bot size={14} style={{ marginRight: '4px', verticalAlign: 'middle' }} />
          <span>IA</span>
        </button>
        <button
          type="button"
          className={`tab-button ${activeTab === 'flashcards' ? 'active' : ''}`}
          onClick={() => onTabChange('flashcards')}
          disabled={disableTabs}
          role="tab"
          aria-selected={activeTab === 'flashcards'}
        >
          <BookOpen
            size={14}
            style={{ marginRight: '4px', verticalAlign: 'middle' }}
          />
          <span>Cards</span>
        </button>
        <button
          type="button"
          className={`tab-button ${activeTab === 'quiz' ? 'active' : ''}`}
          onClick={() => onTabChange('quiz')}
          disabled={disableTabs}
          role="tab"
          aria-selected={activeTab === 'quiz'}
        >
          <Gamepad2
            size={14}
            style={{ marginRight: '4px', verticalAlign: 'middle' }}
          />
          <span>Quiz</span>
        </button>
      </div>

      <div className="ai-pane__body" role="tabpanel">
        {activeTab === 'ai' ? (
          <AIInterface
            pdfData={pdfData}
            currentPage={currentPage}
            setIsLoadingAnswer={setIsLoadingAnswer}
            setAnswerText={setAnswerText}
          />
        ) : activeTab === 'flashcards' ? (
          <FlashCards pdfData={pdfData} />
        ) : (
          <QuizGame pdfData={pdfData} />
        )}
      </div>
    </aside>
  );
};

export default AiPane;
